export function hslToHex(h: number, s: number, l: number) {
  s /= 100;
  l /= 100;
  const k = (n: number) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  const toHex = (x: number) => {
    const hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };

  const r = toHex(f(0));
  const g = toHex(f(8));
  const b = toHex(f(4));

  return `#${r}${g}${b}`;
}

export function hslStringToHex(hslString: string) {
  // Parse the HSL string (e.g., hsl(-160, 100%, 96%))
  const hslRegex = /hsl\(\s*(-?\d+),\s*(\d+)%?,\s*(\d+)%?\)/;
  const result = hslRegex.exec(hslString);

  if (hslString.startsWith('#')) {
    return hslString;
  }

  if (!result) {
    // eslint-disable-next-line no-untranslated-string/no-untranslated-string
    throw new Error('Invalid HSL format');
  }

  // Extract the values
  const h = parseInt(result[1], 10);
  const s = parseInt(result[2], 10);
  const l = parseInt(result[3], 10);

  return hslToHex(h, s, l);
}

export const getContrastYIQ = (hexColor: string) => {
  const r = parseInt(hexColor.substring(1, 3), 16);
  const g = parseInt(hexColor.substring(3, 5), 16);
  const b = parseInt(hexColor.substring(5, 7), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'dark' : 'light';
};

export const hashStringToNumber = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    // eslint-disable-next-line no-bitwise
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

export const nameToHslColor = (name: string, s: number, l: number, t?: number) => {
  const userId = hashStringToNumber(name).toString();

  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = userId.charCodeAt(i) + ((hash << 6) - hash);
  }

  const h = hash % 360;

  if (t) {
    // eslint-disable-next-line no-untranslated-string/no-untranslated-string
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%, ' + t + '%)';
  } else {
    // eslint-disable-next-line no-untranslated-string/no-untranslated-string
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
  }
};
